/**
 * The scorecard arithmetic, a verbatim copy of the backend's
 * `data-models/project/validation-scoring.ts` (minus the recommendation rule,
 * which only the summary job applies) so the stage view and the summary band
 * and round scores the same way the job does.
 */

export const SCORE_STRONG_MIN = 7; // strong: 7–10
export const SCORE_MIXED_MIN = 4; // mixed: 4–6.9; weak: 1–3.9

export type ScoreBand = 'strong' | 'mixed' | 'weak';

export function scoreBand(score: number): ScoreBand {
  if (score >= SCORE_STRONG_MIN) return 'strong';
  if (score >= SCORE_MIXED_MIN) return 'mixed';
  return 'weak';
}

/** One decimal, as every score is shown. */
export function roundScore(score: number): number {
  return Math.round(score * 10) / 10;
}

/** Mean of the scores, one decimal; 0 for an empty list. */
export function meanScore(scores: number[]): number {
  if (scores.length === 0) return 0;
  return roundScore(scores.reduce((sum, s) => sum + s, 0) / scores.length);
}

/** The score as a one-decimal string, without a trailing ".0". */
export function formatScore(score: number): string {
  return Number.isInteger(score) ? String(score) : score.toFixed(1);
}
